import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { viewerDisabledProps } from "../utils/permissions";

// Employee Form ke saare fields (profile image chhodkar — wo Excel se nahi aa sakti)
const TEMPLATE_COLUMNS = [
  "employee_name",
  "father_name",
  "gender",
  "mobile",
  "employee_code",
  "kitchen_id",
  "date_of_birth",
  "joining_date",
  "exit_date",
  "address",
  "location",
  "bank_name",
  "account_number",
  "ifsc_code",
  "pf_no",
  "uan_no",
  "esic_no",
  "esic_benefits",
  "epf_benefits",
  "total_monthly_ctc",
];

const AddEmployeeBulk = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [kitchens, setKitchens] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null); // { created_count, skipped, errors, created_employees }

  useEffect(() => {
    axios
      .get("https://ims-attendanceback.indevconsultancy.in/api/kitchen-list")
      .then((res) => setKitchens(res.data.kitchens || []))
      .catch(() => setKitchens([]));
  }, []);

  // Sample Excel — sahi column names ke saath ek example row.
  const handleDownloadTemplate = () => {
    const example = {
      employee_name: "Ram Kumar",
      father_name: "Shyam Kumar",
      gender: "Male",
      mobile: "9876543210",
      employee_code: "A0100",
      kitchen_id: kitchens[0]?.kitchenid || 1,
      date_of_birth: "01/01/1990",
      joining_date: "01/07/2026",
      exit_date: "",
      address: "Delhi",
      location: "Delhi",
      bank_name: "SBI",
      account_number: "12345678901",
      ifsc_code: "SBIN0001234",
      pf_no: "DL/12345/678",
      uan_no: "100123456789",
      esic_no: "1234567890",
      esic_benefits: "Yes",
      epf_benefits: "Yes",
      total_monthly_ctc: "15000",
    };
    const ws = XLSX.utils.json_to_sheet([example], { header: TEMPLATE_COLUMNS });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Employees");
    // Dusri sheet me kitchen id ki list — file bharne me aasani ke liye.
    if (kitchens.length) {
      const kitchenRows = kitchens.map((k) => ({
        kitchen_id: k.kitchenid,
        kitchen_name: k.kitchen_name,
      }));
      const wsK = XLSX.utils.json_to_sheet(kitchenRows);
      XLSX.utils.book_append_sheet(wb, wsK, "Kitchen IDs");
    }
    XLSX.writeFile(wb, "Bulk_Employee_Template.xlsx");
  };

  const handleReset = () => {
    setFile(null);
    setResult(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      Swal.fire("Select the file", "warning");
      return;
    }
    setUploading(true);
    setResult(null);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("added_by", localStorage.getItem("user_id") || "");

      const res = await axios.post(
        "https://ims-attendanceback.indevconsultancy.in/api/bulkupload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const data = res.data;
      setResult(data);

      const created = data.created_count || 0;
      const skippedCount = data.skipped_count || (data.skipped || []).length;
      const errorCount = (data.errors || []).length;

      if (skippedCount > 0 || errorCount > 0) {
        // Alert me skipped records ki list dikhao
        const skippedLines = (data.skipped || [])
          .slice(0, 10)
          .map((s) => `Row ${s.row}: ${s.name || "-"} — ${s.reason}`)
          .join("<br/>");
        const moreNote =
          skippedCount > 10 ? `<br/><i>...aur ${skippedCount - 10} records (neeche table me dekhें)</i>` : "";
        Swal.fire({
          icon: "warning",
          title: `${created} employees added, ${skippedCount} skipped`,
          html: `<div style="text-align:left;font-size:13px">${skippedLines}${moreNote}</div>`,
          width: 600,
        });
      } else {
        Swal.fire("Success", `${created} employees added successfully`, "success");
      }
    } catch (err) {
      console.error("Bulk upload failed:", err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Upload failed. File format check करें.",
        "error"
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="bg-cream min-vh-100 py-2">
      <div className="container-fluid my-4">
        <div className="card shadow-lg">
          <div className="card-header bg-skyBlue text-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Bulk Employee Upload</h5>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => navigate("/employeeList")}
            >
              ← Employee List
            </button>
          </div>
          <div className="card-body">
            {/* <div className="alert alert-info py-2 small mb-3">
              Excel (.xlsx) upload करें — columns:{" "}
              <code>{TEMPLATE_COLUMNS.join(", ")}</code>
              <br />
              जो employee पहले से registered है (mobile / account number /
              employee code active employee से match हुआ) वो row{" "}
              <strong>skip</strong> हो जाएगी और आपको list दिख जाएगी।
            </div> */}

            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                <div className="col-md-6">
                  <label className="form-label">Excel File</label>
                  <input
                    type="file"
                    className="form-control"
                    name="file"
                    accept=".xlsx,.xls"
                    ref={fileInputRef}
                    onChange={(e) => setFile(e.target.files[0] || null)}
                  />
                </div>
                <div className="col-md-6 d-flex gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={handleDownloadTemplate}
                  >
                    Sample Template
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={uploading || !file}
                    {...viewerDisabledProps()}
                  >
                    {uploading ? "Uploading…" : "Upload"}
                  </button>
                </div>
              </div>
            </form>

            {/* ── Result summary ────────────────────────────── */}
            {result && (
              <div className="mt-4">
                <div className="d-flex gap-3 mb-3">
                  <span className="badge bg-success fs-6">
                    Added: {result.created_count || 0}
                  </span>
                  <span className="badge bg-warning text-dark fs-6">
                    Skipped: {result.skipped_count || 0}
                  </span>
                  {(result.errors || []).length > 0 && (
                    <span className="badge bg-danger fs-6">
                      Errors: {result.errors.length}
                    </span>
                  )}
                </div>

                {(result.skipped || []).length > 0 && (
                  <>
                    <h6 className="text-warning-emphasis">
                      Skipped Records (Already registered / invalid)
                    </h6>
                    <div className="table-responsive mb-3">
                      <table className="table table-bordered table-sm">
                        <thead className="table-light">
                          <tr>
                            <th>Excel Row</th>
                            <th>Name</th>
                            <th>Reason</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.skipped.map((s, i) => (
                            <tr key={i}>
                              <td className="text-center">{s.row}</td>
                              <td>{s.name || "-"}</td>
                              <td>{s.reason}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {(result.errors || []).length > 0 && (
                  <>
                    <h6 className="text-danger">Errors</h6>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead className="table-light">
                          <tr>
                            <th>Excel Row</th>
                            <th>Name</th>
                            <th>Error</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.errors.map((s, i) => (
                            <tr key={i}>
                              <td className="text-center">{s.row}</td>
                              <td>{s.name || "-"}</td>
                              <td>{s.reason}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            )}

            {/* ── Kitchen ID reference ──────────────────────── */}
            {kitchens.length > 0 && (
              <div className="mt-4">
                {/* <h6>Kitchen ID Reference (file me kitchen_id yahi डालें)</h6> */}
                <div className="table-responsive" style={{ maxHeight: 250, overflowY: "auto" }}>
                  <table className="table table-bordered table-sm table-striped">
                    <thead className="table-light">
                      <tr>
                        <th>Kitchen ID</th>
                        <th>Kitchen Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {kitchens.map((k) => (
                        <tr key={k.kitchenid}>
                          <td className="text-center">{k.kitchenid}</td>
                          <td>{k.kitchen_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployeeBulk;
